'use client'

import { useEffect } from 'react'

/**
 * The root layout owns the <html> element and renders lang="en"; nested
 * layouts cannot override it server-side in the App Router. This sets the
 * document language client-side for localized routes so screen readers and
 * translation tooling see the correct language. Search engines rely on the
 * hreflang alternates + JSON-LD inLanguage, which are already server-rendered.
 */
export function SetHtmlLang({ lang }: { lang: string }) {
  useEffect(() => {
    const prev = document.documentElement.lang
    document.documentElement.lang = lang
    return () => {
      document.documentElement.lang = prev
    }
  }, [lang])

  return null
}
